import React, { createContext, useContext } from 'react'
import { useRaisedHands, type RaisedHands } from '../../../hooks/useRaisedHands'

export interface SharedRaisedHands extends RaisedHands {
  /** False while the local player is alone: raise hand is offered only when someone can see it. */
  canRaiseHand: boolean
}

const RaisedHandsContext = createContext<SharedRaisedHands | null>(null)

/**
 * The office-wide raise-hand state, owned by `LiveKitVideoDisplayController` so
 * the call bar, the video tiles and the presentation views share one set of
 * schema listeners (two would chime and toast twice while a view is open).
 */
export const RaisedHandsProvider = RaisedHandsContext.Provider

/**
 * Raise-hand state for a presentation view: the controller's shared instance
 * when mounted under it, otherwise a local one for `room` (standalone renders,
 * tests). The local instance is inert whenever the shared one exists.
 */
export function useSharedRaisedHands(room: any | null): SharedRaisedHands {
  const shared = useContext(RaisedHandsContext)
  const own = useRaisedHands(shared ? null : room)
  return shared ?? { ...own, canRaiseHand: true }
}
